import { render } from "./RectangleMap.vue?vue&type=template&id=7a7f1f10"
import script from "./RectangleMap.vue?vue&type=script&lang=js"
export * from "./RectangleMap.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__